// extracted by mini-css-extract-plugin
export default {"container":"InBStatus_container__WzLc6","title":"InBStatus_title__2iiaI","list":"InBStatus_list__z1pSQ"};